import React from "react"
import { Flex, HStack, Text, Container } from "@chakra-ui/react"

export default function CopyRight({ data }) {
  return (
    <Container mt={0} mb={0}>
      <HStack spacing={4}>
        <Text size="xs" ml="auto">
          &#169; {new Date().getFullYear()}{" "}
        </Text>
      </HStack>
    </Container>
  )
}
